import React, {FC} from 'react'
import {GlobalErrorPage} from "@/src/components/pages";


export const MaintancePage: FC = () => {

    return (
        <GlobalErrorPage
            title={"Ведуться технічні роботи!"}
            description={
                "Ми працюємо над тим, щоб якнайшвидше відновити роботу сайту. Поверніться пізніше — ми вас чекатимемо!"
            }
            image={{
                src: "/images/global-error.png",
                alt: "Global error image",
                width: 200,
                height: 205,
            }}
        />
    )
}
